import React, { useState } from 'react';
import getCountryFlag from 'country-flag-icons/unicode';
import multiLangDomains from '../../constants/multiLang';
import { config } from '../../constants/domainConfig';
import { hasFlag } from 'country-flag-icons';
import useSetLanguage from '../../hooks/useSetLanguage';

const LanguagesDropdown = () => {
    const { lang, subdomain } = config;
    const languages = multiLangDomains[subdomain];

    const [language, setLanguage] = useState(lang);
    const [open, setOpen] = useState(false);

    const { handleLanguageChange } = useSetLanguage();

    const handleSelect = (value) => {
        setLanguage(value);
        handleLanguageChange(value);
        setOpen(false);
    };

    const getFlag = (value) => {
        const code = value === 'en' ? 'US' : value.toUpperCase();
        return hasFlag(code) ? getCountryFlag(code) : '';
    };

    return (
        <div className="language_container">
            <div className="language_section" onClick={() => setOpen((prev) => !prev)}>
                <div className="lang_left">
                    <span className="flag">{getFlag(language)}</span>
                    {/* <span className="lang_label">{languages.find((l) => l.value === language).label}</span> */}
                </div>

                <span className="lang_arrow">{open ? '▲' : '▼'}</span>
            </div>

            {open && (
                <div className="language_model">
                    {languages.map(({ label, value }) => {
                        const isActive = language === value;

                        return (
                            <div key={value} className="language_option" onClick={() => handleSelect(value)}>
                                <div className={`lang_left ${isActive ? 'active-lang' : ''}`}>
                                    <span className="flag">{getFlag(value)}</span>
                                    <span>{label}</span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default LanguagesDropdown;
